export default __webpack_public_path__ + "static/media/about-heror-img.55b7cd00.png";